import { render, staticRenderFns } from "./ctx-menu.vue?vue&type=template&id=0ca8f599&scoped=true"
import script from "./ctx-menu.vue?vue&type=script&lang=js"
export * from "./ctx-menu.vue?vue&type=script&lang=js"
import style0 from "./ctx-menu.vue?vue&type=style&index=0&id=0ca8f599&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca8f599",
  null
  
)

export default component.exports